// src/services/payoutService.js
import api from './api'; // Assuming `api` is your axios instance
import axios from 'axios'; // You may not need `axios` if you're using `api` consistently

// Fetch eligible orders for payout
export const fetchEvaluatedOrdersWithHighScore = async () => {
  try {
    const response = await api.get('/payouts/eligible-orders');
    console.log('[payoutService] Fetched eligible orders:', response.data);
    return response.data;
  } catch (error) {
    console.error('[payoutService] Error fetching eligible orders:', error);
    throw error;
  }
};




// Approve selected orders
export const approveSelectedOrders = async (orderIds) => {
  try {
    const response = await api.post('/payouts/approve-orders', { orderIds }); // Use the `api` instance consistently
    console.log('[payoutService] Approved orders:', response.data);
    return response.data;
  } catch (error) {
    console.error('[payoutService] Error approving selected orders:', error);
    throw error;
  }
};
